import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";

import {
  Card,
  CardBody,
  Row,
  Col,
  Button
} from "reactstrap";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Alert } from 'reactstrap';
import LoadingScreen from "react-loading-screen";

import { Checkbox} from "react-inputs-validation";
import "../../styles/estilos.css";
import Page from "components/Page";
import {encriptarTramaAES} from "../../utils/Encriptar/index"
import { fetchGuardarCarritoFinanciero} from "../../redux/actions/aRamoLineaFinanciera";


class CotizacionFinanciero2 extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      listarPreguntas: [],
      valPreguntas : false,
      valAlerta: false
    };
    this.onClick = this.handleClick.bind(this);
  }

  async handleClick(e) {
    const { listarPreguntas } = this.state;
    let contador=0;
    let arrayPreguntas = []
    listarPreguntas.forEach(item => {
      if(item.checkedSI===undefined || (!item.checkedSI && !item.checkedNO)){
        contador++;
      }else{
        if (item.checkedSI) 
          arrayPreguntas.push({ pregCodigoCore: item.pregCodigoCore, pregRespuesta: true })
        else
          arrayPreguntas.push({ pregCodigoCore: item.pregCodigoCore, pregRespuesta: false})
      }
    });
    if(contador>0){
      this.setState({ valPreguntas:true });
    }else{
        const datosJSON = {
          idCarrito: this.props.detalleCarrito.ultimoPaso.resultado.idCarrito,
          respuestas: arrayPreguntas
        }
        const datosJSON2 = {
          paso:"2",
          preguntas: datosJSON
        }
      const encriptado = encriptarTramaAES(JSON.stringify(datosJSON2));
      await this.props.guardarCarrito({"Data": Buffer.from(JSON.stringify(encriptado)).toString('base64')});  
      if(this.props.respuestaCarrito.respuestaGuardarFinanciero.errorDescripcion===undefined){
          /*Pasa a la siguiente pantalla*/      
          this.props.history.push({
            pathname: "/limites-cotizacion-financiero",
            search: `?${
              new URLSearchParams({
                preservar: this.props.preservar
              }).toString()
            }`
          });
      }else{
        this.setState({
          valAlerta: true
        });
      }
    }
  }

  componentDidUpdate(prevState,prevProps){
    if (this.props.listarPreguntas !== prevProps.listarPreguntas) 
      this.actualizarArray()
  }

  actualizarArray = () => {
    let { listarPreguntas } = this.props;

    for (let i = 0; i < listarPreguntas.length; i++) {
      if(listarPreguntas[i].pregRespuesta !== undefined){
        if(listarPreguntas[i].pregRespuesta){
          listarPreguntas[i] = { ...listarPreguntas[i], checkedSI: true , checkedNO: false  }
        }else{
          listarPreguntas[i] = { ...listarPreguntas[i], checkedNO: true, checkedSI: false  }
        }
      }
      else 
      {
        if(listarPreguntas[i].checkedSI!==undefined && listarPreguntas[i].checkedNO!==undefined){
            if(listarPreguntas[i].checkedSI){
                listarPreguntas[i] = { ...listarPreguntas[i], pregRespuesta:true  }
            }
        }
      }
    }
    this.setState({ listarPreguntas })
  }
  componentDidMount() {
    window.scroll(0, 0);
    this.actualizarArray()
  }

  render() {
    const {listarPreguntas,valPreguntas,valAlerta} = this.state;
    const {respuestaCarrito,detalleCarrito} = this.props;
    return (
      <LoadingScreen
        loading={respuestaCarrito.guardarCarritoFinancieroIsLoading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text="Guardando información. Por favor espere..."
      >
        <Page
        title={detalleCarrito.carDescripcionSeguro}
        breadcrumbs={[{ name: `${detalleCarrito.carDescripcionSeguro}`, active: true }]}
        >
          <div className="container-step">
            <div className="wrapper-step">
              <div className="arrow-steps clearfix-step">
                <div className="step current"> {` 1. Cotización `} </div>
                <div className="step"> {` 2. Resumen `} </div>
                <div className="step"> {` 3. Confirmación `} </div>
                <div class="step"> {` 4. Forma de Pago `} </div>
                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                <div class="step"> {` 6. Emisión `} </div>
              </div>
            </div>
          </div>
          <Row>
            <Col md={10} sm={12} className="div-align-center">
              <Card className="flex-row ">
                <CardBody>
                  <h4 style={{ fontWeight: "bold" }} className='mb-5 mt-3'>Confirmación del estatus del asegurado</h4>
                  <Col md={11} sm={11}  className="div-align-center">
                    <Row className='mb-3'>
                      <Col md={12} sm={12} >
                          <h6>Confirmo que la sociedad y sus subsidiarias</h6>
                      </Col>
                    </Row>
                    {listarPreguntas !== undefined && 
                      listarPreguntas.map((preguntas, i) => {
                        return (
                          <div key={i}>
                          <Row >
                            <Col md={8} sm={12} xs={12} className="div-align-center">
                                <p style={{ fontWeight: "200", textAling:"justify"}}>{preguntas.pregDescripcion}</p>
                            </Col>
                            <Col md={4} sm={12} xs={12} className="div-align-center" >
                              <Row>
                                <Col md={6} sm={6} xs={6} >
                                  <Checkbox
                                        id={`preguntaSI${preguntas.pregCodigoCore}`} // Optional.[String].Default: "".  Input ID.
                                        name={`preguntaSI${preguntas.pregCodigoCore}`}
                                        //value={factotal} // Required.[String].Default: "".
                                        onBlur={() => {}} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                        checked={preguntas.checkedSI} // Required.[Bool].Default: false.
                                        onChange={(res, e) => {
                                          if(!res)
                                            listarPreguntas[i] = { ...listarPreguntas[i], checkedSI: res}
                                          else
                                            listarPreguntas[i] = { ...listarPreguntas[i], checkedSI: res, checkedNO: !res}
                                          this.setState({ listarPreguntas, valAlerta:false, valPreguntas: false })
                                        }}
                                        labelHtml={
                                            <div style={{ color: '#4a4a4a', marginTop: '2px', fontWeight:"bold"}}>
                                            SI
                                            </div>
                                        } // Required.[Html].Default: none.
                                        validationOption={{
                                            name: 'preguntaSI', // Optional.[String].Default: "". To display in the Error message. i.e Please check the ${name}.
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                        }}
                                    />
                                </Col>
                                <Col md={6} sm={6} xs={6} >
                                  <Checkbox
                                        id={`preguntaNO${preguntas.pregCodigoCore}`} // Optional.[String].Default: "".  Input ID.
                                        name={`preguntaNO${preguntas.pregCodigoCore}`}
                                        //value={factotal} // Required.[String].Default: "".
                                        onBlur={() => {}} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                        checked={preguntas.checkedNO} // Required.[Bool].Default: false.
                                        onChange={(res, e) => {
                                        if(!res)
                                          listarPreguntas[i] = { ...listarPreguntas[i], checkedNO: res}
                                        else
                                          listarPreguntas[i] = { ...listarPreguntas[i], checkedNO: res, checkedSI: !res}
                                          this.setState({ listarPreguntas, valAlerta:false, valPreguntas: false })
                                        }}
                                        labelHtml={
                                            <div style={{ color: '#4a4a4a', marginTop: '2px', fontWeight:"bold"}}>
                                            NO
                                            </div>
                                        } // Required.[Html].Default: none.
                                        validationOption={{
                                            name: 'preguntaNO', // Optional.[String].Default: "". To display in the Error message. i.e Please check the ${name}.
                                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                        }}
                                    />
                                </Col>
                              </Row>
                            </Col>
                          </Row>   
                          <hr></hr>
                          </div>
                        );      
                      })
                    }  
                    {valPreguntas &&
                      <Row >
                        <Col md={10} sm={12} className="div-align-center">
                          <Alert color="danger">
                            <p style={{ textAlign: "center" }}><i className="fa fa-exclamation-triangle fa-2x" aria-hidden="true" ></i></p>
                            <p style={{ textAlign: "center" }}>{"Para continuar debe responder todas las preguntas"}</p>

                          </Alert>
                        </Col>
                      </Row>
                    }

                    {valAlerta &&
                      <Row >
                        <Col lg={12} md={12} sm={12} xs={12} className="div-align-center">
                          <Alert color="warning">
                            <p style={{textAlign:"center"}}><i className="fa fa-exclamation-triangle fa-3x" aria-hidden="true" ></i></p>
                            <p>{this.props.respuestaCarrito.respuestaGuardarFinanciero.errorDescripcion}</p>
                          </Alert>
                        </Col>
                      </Row>
                    }                    
                    <Row>                    
                      {/* <Col lg={12} md={12} sm={12} xs={12} className="div-align-center"> */}
                      <Col lg={6} md={6} sm={6} xs={6} className="mt-3">
                        <Button className="btn btn-detail-gray" onClick={() => this.props.handleBack()} style={{ display: "block", margin: "auto" }}  >
                          <i className="fa fa-chevron-circle-left" aria-hidden="true" />{"   REGRESAR"}
                        </Button>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={6} className="mt-3" >
                        <div className="div-align-rigth">
                          <Button className="btn btn-primary" onClick={() => this.handleClick()} style={{ display: "block", margin: "auto" }} >
                            <i className="fa fa-chevron-circle-right" aria-hidden="true" />{"  CONTINUAR"}
                          </Button>
                        </div>
                      </Col>
                      {/* </Col>                        */}
                    </Row>
                  </Col>
               </CardBody>
             </Card>
            </Col>
         </Row>      
        </Page>
      </LoadingScreen>
    );
  }
}

const mapStateToProps = state => ({
  respuestaCarrito : state.datosCotizacionFinanciero
});


const mapDispatchToProps = dispatch => {
  return {
    guardarCarrito: (data) => dispatch(fetchGuardarCarritoFinanciero(data)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CotizacionFinanciero2)
);
